<div class="container">
  <div class="card">
    <div class="card-content p-3 h-100">
      <div class="d-flex align-items-start justify-content-between flex-column card-body-div">
        <div>
          <h3 class="mb-lg-2 mb-4 text-white">{{ 'voucher.title' | translate: { fgbdefault: 'VOUCHER CODE' } }}</h3>
        </div>
        <div class="d-flex align-items-center w-100">
          <span class="voucher-input d-flex align-items-center flex-lg-row flex-column w-100">
            <input
              onfocus="this.placeholder = ''"
              onblur="this.placeholder = 'Enter Code'"
              type="text"
              (input)="clearMessages()"
              [(ngModel)]="voucherCode"
              placeholder="{{ 'voucher.input.placeholder' | translate }}"
              class="form-control me-lg-3 bg-glass mb-lg-0 mb-3"
              (keyup.enter)="redeemVoucher()"
            />
            <div class="voucher-input-btn">
              <button
                class="btn btn-quaternary text-black d-flex align-items-center justify-content-center"
                type="button"
                (click)="redeemVoucher()"
                [disabled]="disableButton"
              >
                <span class="font-size-14 fw-bold"> {{ 'voucher.apply.btn.text' | translate: { fgbdefault: 'Apply' } }} </span>
              </button>
            </div>
          </span>
        </div>
      </div>
      <div
        class="d-flex align-items-lg-end align-items-start justify-content-center card-body-div result-div"
        [style.background-image]="
          'url(' +
          (isMobileView
            ? ('placeholders/vouchermobile.svg' | contentAssetImage)
            : ('placeholders/voucher.svg' | contentAssetImage)) +
          ')'
        "
      >
        <div class="result-box w-100 px-2">
          <div
            class="result bg-voucher-error w-100 px-3 border border-danger"
            *ngIf="errorService.hasErrors() && voucherError && voucherError.Code == 'Vouchers.CODE.90250'"
          >
            <span class="material-symbols-outlined text-danger me-2">cancel</span>
            <fgbcl-errors></fgbcl-errors>
          </div>
          <div
            class="result bg-voucher-success w-100 px-3 border border-success"
            *ngIf="redemptionResult && voucherCode && sucessfulRedemption"
          >
            <span class="material-symbols-outlined text-success me-2">check_circle</span>
            <div class="font-size-14 fw-bold text-success text-center">
              {{ redemptionResult }}
            </div>
          </div>
          <div
            class="result bg-tertiary text-white w-100 px-3 border border-grey"
            *ngIf="redemptionResult && !voucherCode && !sucessfulRedemption"
          >
            <span class="material-symbols-outlined text-white me-2">warning</span>
            <div class="font-size-14 fw-bold text-white text-center">
              {{ redemptionResult }}
            </div>
          </div>
          <div
            class="result bg-tertiary text-white w-100 px-3 border border-grey"
            *ngIf="errorService.hasErrors() && voucherError && voucherError.Code == 'Vouchers.CODE.90251'"
          >
            <span class="material-symbols-outlined text-white me-2">schedule</span>
            <div class="font-size-14 fw-bold text-white text-center">
              <fgbcl-errors></fgbcl-errors>
            </div>
          </div>
          <div
            class="result bg-tertiary text-white w-100 px-3 border border-grey"
            *ngIf="errorService.hasErrors() && voucherError && voucherError.Code == 'Vouchers.CODE.90252'"
          >
            <span class="material-symbols-outlined text-white me-2">block</span>
            <div class="font-size-14 fw-bold text-white text-center">
              <fgbcl-errors></fgbcl-errors>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
